export default {
    formId: 'suscripcionesForm',
    formField: {
        customerId: {
            name: 'customerId',
            label: 'Cliente / Empresa *',
            requiredErrorMsg: 'El cliente es requerido.'
        },
        planId: {
            name: 'planId',
            label: 'Plan *',
            requiredErrorMsg: 'El plan es requerido.'
        },
        startsAt: {
            name: 'startsAt',
            label: 'Fecha de Inicio *',
            requiredErrorMsg: 'La fecha de inicio es requerida.'
        },
        expiresAt: {
            name: 'expiresAt',
            label: 'Fecha de Expiración *',
            requiredErrorMsg: 'La fecha de expiración es requerida.'
        },
        renewalType: {
            name: 'renewalType',
            label: 'Tipo de Renovación *',
            requiredErrorMsg: 'El tipo de renovación es requerido.'
        },
        monthlyCredits: {
            name: 'monthlyCredits',
            label: 'Créditos Mensuales',
            requiredErrorMsg: 'Los créditos mensuales son requeridos.'
        },
        nextRenewalAt: {
            name: 'nextRenewalAt',
            label: 'Próxima Renovación',
            requiredErrorMsg: 'La próxima renovación es requerida.'
        },
        statusSuscription: {
            name: 'statusSuscription',
            label: 'Estado *',
            requiredErrorMsg: 'El estado es requerido.'
        }
    }
};
